import { InformativePage } from "../components";

interface TermsAndConditionsPageContentProps {
  page: any;
}

export function TermsAndConditionsPageContent({
  page,
}: TermsAndConditionsPageContentProps) {
  return <InformativePage page={page} />;
}
